import { ApiSettings } from './api-settings'
import { ConfigSettings } from './config-settings'

export type EnvironmentVariable = Record<string, string | undefined>

export enum EnvironmentsTypes {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
  STAGING = 'STAGING',
}

export class EnvironmentSettings {
  constructor(private env: EnvironmentsTypes) {}

  get getEnv() {
    return this.env
  }

  get isDevelopment() {
    return this.env === 'DEVELOPMENT'
  }

  get isProduction() {
    return this.env === 'PRODUCTION'
  }

  get isStaging() {
    return this.env === 'STAGING'
  }
}

class AppSettings {
  constructor(
    public env: EnvironmentSettings,
    public api: ApiSettings,
    public config: ConfigSettings
  ) {}
}

const env = new EnvironmentSettings(process.env.REACT_APP_ENV as EnvironmentsTypes)
const api = new ApiSettings(process.env)
const config = new ConfigSettings(process.env)

export const appSettings = new AppSettings(env, api, config)
